<!--
 * @Descripttion: 原件列表
 * @Author: juanjuanhui
 * @Date: 2022-05-19 09:41:47
 * @LastEditors: juanjuanhui
 * @LastEditTime: 2022-05-19 10:50:24
-->
<template>
  <div class="content">
    <ul class="list">
      <li class="item" v-for="(item, index) in originalFileList" :key="index">
        <el-image :src="item.picPath" :preview-src-list="filePreviewList">
        </el-image>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "OrderOriginal",
  data() {
    return {
      originalFileList: [],
    };
  },
  props: {
    type: {
      type: Number, //附件类型 2 合同原件 3订单原件 4结算凭证
    },
    bizId: {
      type: String,
    },
  },
  mounted() {
    this.getOriginalFileList();
  },
  computed: {
    filePreviewList() {
      let tempAry = [];
      this.originalFileList.forEach((item) => {
        tempAry.push(item.picPath);
      });
      return tempAry;
    },
  },
  methods: {
    /**
     * @descripttion: 获取原件数据
     * @Author: juanjuanhui
     * @Date: 2022-05-19 10:46:38
     */
    getOriginalFileList() {
      let { type, bizId } = this;
      this.$http.common.getContractFileList({ type, bizId }).then((res) => {
        this.originalFileList = res.data;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.list {
  display: flex;
  flex-wrap: wrap;
  .item {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 13.6%;
    height: 280px;
    margin-right: 0.8%;
    margin-bottom: 0.8%;
    background-color: #ffffff;
    border: solid 1px #e3e8eb;
    box-sizing: border-box;
    @media (max-width: 1500px) {
      width: 16%;
      height: 240px;
      margin-right: 0.8%;
      margin-bottom: 0.8%;
      &:nth-child(6n) {
        margin-right: 0;
      }
      &:nth-child(7n) {
        margin-right: 0.8% !important;
      }
    }
    &:nth-child(7n) {
      margin-right: 0;
    }
  }
}
</style>
